export const GET_RESTATISTICAL_REPORT_LIST_START = "GET_RESTATISTICAL_REPORT_LIST_START";
export const GET_RESTATISTICAL_REPORT_LIST_SUCCESS = "GET_RESTATISTICAL_REPORT_LIST_SUCCESS";
export const GET_RESTATISTICAL_REPORT_LIST_FAILURE = "GET_RESTATISTICAL_REPORT_LIST_FAILURE";

export const SEARCH_RESTATISTICAL_NAME = "SEARCH_RESTATISTICAL_NAME";